export const displayValue = (value, fallback = '—') => {
  if (value === null || value === undefined || value === '') return fallback;
  return value;
};

export const formatCurrency = (value) => {
  const num = Number(value);
  if (isNaN(num) || num === 0) return '0 ₽';
  return num.toLocaleString('ru-RU') + ' ₽';
};

export const formatQuantity = (value) => {
  const num = Number(value);
  if (isNaN(num)) return '0';
  if (Number.isInteger(num)) return num.toString();
  return num.toFixed(2);
};